<template>
   <div class="picker-modal linked-products active" v-if="items">
     <div class="overlay"></div>
      <div class="content">
        <div class="top-row">
          <div class="title">
            <h2>{{ $t('general.label.linked-products') }}</h2>
          </div>
          <span class="close-button" @click="goToCart"></span>
        </div>

        <div class="component item-list list">
          <ol>
            <li v-for="(item, index) in items" :key="index">
              <div class="component item-list-summary summary-product">

                <img :src="item.imageUrl" alt="" class="image-small">

                <div class="info">
                  <div class="name">{{ item.name }}</div>
                   <div class="input">

                    <div class="quantity">
                      <div class="price">{{ displayPrice(item) }}</div>
                      <quantity-picker @input="quantityUpdated" v-if="cartItems[index]" v-model="cartItems[index].quantity" :max="item.percentageType ? 1 : undefined"/>
                    </div>
                  </div>
                  <div class="linked-product-details" v-if="item.description">
                      <input :id="`description-toggle_${item.$id}`" class="toggle-button" type="checkbox">
                      <label :for="`description-toggle_${item.$id}`">{{ $t('general.label.details') }}</label>
                      <p v-html="item.description"></p>
                    </div>
                </div>
              </div>
            </li>
          </ol>
        </div>

        <div class="actions">
          <!-- <button class="secondary" @click="skip">{{ $t('form.label.skip') }}</button> -->
          <button class="primary" @click="updateAndGoToCart">
            <span v-if="anySelected">{{ $t('form.label.add-and-continue') }}</span>
            <span v-else>{{ $t('form.label.continue') }}</span>
          </button>
        </div>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import ItemList from '@/components/ItemList';
import ModalConfirm from '@/components/ModalConfirm';
import i18n  from '@/i18n';
import QuantityPicker from '@/components/QuantityPicker';
import Cart from '@/models/Cart';
import CartItem from '@/models/CartItem';
import BodyClasses from '@/include/bodyClasses';

export default{
   props: [
      'items',
      'nextRoute',
   ],
   data() {
    return {
      cartItems: [],
      anySelected: false
    }
   },

   components: {
    QuantityPicker
   },

   mounted(){
    this.updateItems(this.items);
    BodyClasses.setClass('modal-active', true);
   },

   watch:{
    items: function(newItems){
      this.updateItems(newItems);
    },
   },

   methods: {
    displayPrice(item) {
      return this.$formatter.currency(item.price);
    },

    updateItems(newItems){
      this.cartItems = [];
      for (var i = 0; i < newItems.length; i++){
        let existingItem = this.$cart.active.findItem(newItems[i].id, 'product');
        var qty = 0;
        var id;
        if (existingItem){
          qty = existingItem.quantity;
          id = existingItem.id;
        }

        let cartItem = new CartItem({ itemId: newItems[i].id, type: 'product', quantity: qty, linkedToTourId: newItems[i].linkedToTourId, linkedToPackageId: newItems[i].linkedToPackageId });
        if (id){
          cartItem.id = id;
        }
        this.cartItems.push(cartItem);
      }
    },
      updateAndGoToCart(){
        var vm = this;
        var updates = [];
        for (var i = 0; i < vm.cartItems.length; i++){
          updates.push(Cart.update(vm.cartItems[i]));
        }
        Promise.all(updates).then(function(){
          if (vm.$parent.model.relatedActivities && vm.$parent.model.relatedActivities.length && vm.nextRoute){
            vm.$router.push(vm.nextRoute);
         } else {
            vm.goToCart();
          }
        });
      },

      quantityUpdated(val){
        if (val > 0){
          this.anySelected = true;
          return;
        }
        var any = false;
        this.cartItems.forEach((item) => {
          if (item.quantity > 0){
            this.anySelected = true;
            any = true;
          }
        });
        if (!any)
          this.anySelected = false;
      },

      goToCart(){
         var vm = this;
         // BodyClasses.setClass('modal-active', false);
         // This is necessary to allow mixin watcher to execute before component is destroyed
         vm.$router.push({name: 'cart'});
      },

      closeAndStay(){
         var vm = this;
         // BodyClasses.setClass('modal-active', false);
         // This is necessary to allow mixin watcher to execute before component is destroyed
         vm.$router.push({name: 'activity'});
      }
   }
};

</script>

<style lang="scss">
.info {
    /*  Edge */
    @supports (-ms-ime-align:auto) {
      margin-left: 15px;
    }

    /*  IE */
    -ms-grid-column: 2;
    @media all and (-ms-high-contrast:none) {
      margin-left: 15px;
    }

    .description {
      margin-top: 10px;
      margin-bottom: 0;

      .more {
        margin-left: 5px;
        &::after {
          @include font-awesome-pseudo($fa-var-chevron-down, light);
          margin-left: 5px;
        }
      }
      .less {
        margin-left: 5px;
        &::after {
          @include font-awesome-pseudo($fa-var-chevron-up, light);
          margin-left: 5px;
        }
      }
    }
  }

.linked-products {
  overflow: scroll;
}

.toggle-button {
    display: none;

    + label {
      color: $colorBlue;
      align-items: center;
      cursor: pointer;
      &:hover {
        filter: brightness(1.3);
        // color: lighten($colorBlue, 10);
      }

      &::before {
        content: none !important;
      }

      &::after {
        @include font-awesome-pseudo($fa-var-chevron-down, light);
        margin-left: 5px;
      }
    }

    ~ p {
      margin-bottom: 0;
      max-height: 0;
      overflow: hidden;
    }

    &:checked {
      + label::after {
        transform: rotate(-180deg);
      }

      ~ p {
        max-height: 300px;
        overflow: auto;
        transition: all .2s;
      }
    }
  }

.component.item-list {
  ul, ol {
    @include unlisted;
  }
}

.description {
  margin-top: 10px;
  margin-bottom: 0;
}

.linked-product-details {
  float: left;
}

.top-row {
  height: 70px;
}

.close-button {
  &::after {
    @include font-awesome-pseudo($fa-var-times, light);
    color: $colorGray;
    visibility: visible;
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    font-size: 30px;
  }
}

.title {
  float: left;
  margin-top: 22px;
  margin-left: 15px;
}

.image-small {
  width: 100px;
  height: 100px;
}

.skip {
  float: right;
  padding: 20px;
}
</style>